import React from 'react';
import { Footer } from '../Common/Footer';
import ProductsUpload from '../../Models/ProductsUpload';
import { connect } from 'react-redux';
import { productUpload } from '../../Action/productUpload';
import { withRouter } from 'react-router';
import SimpleReactValidator from 'simple-react-validator';
import axios from 'axios';
import { Header } from '../Common';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';

class ProductUploadConfirmation extends React.Component {
    constructor(props) {

        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert('ログインしてください')
            window.location.href = '/login/seller';
        };
        this.state = {
            modal: false,
            services: [
                {
                    id: 0,
                    serviceName: '',
                    price: '',
                }
            ],

            file: '',
            imagePreviewUrl: '',

            files: [],

            id: '',
            x: '',
            firstTitle: '',
            secondTitle: '',
            description: '',
            servicePrice: '',
            expectedDelivary: '',
            delivaryFormat: '',
            numberOfOrders: '',
            acceptance: '',
            paidForService: '',
            affiliatorPromote: '',
            categories: [],
            subCategories: [],
            affiliatorCommission: [],
            subCategory: '',
            Category: '',
            affCommission: '',
            includeTransaction: '',
            includeVat: '',
            selectedFile: null,
            picture: '',
            singlePictureString: '',
            file: null,
            file1: null,
            file3: null,
            file4: null,
            pictures: [],
            editor_msg: '',
            message: '',
            flag: '',
            IsDraft: '',
            seller_id: '',
            categoryName: this.props.location.state.Category,
        };
        console.log(this.props.location.state.id)
        this.getCategories();
        this.getAffiliatorCommissionName();
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    componentWillReceiveProps(nextProps) {
        ProductsUpload.getCategoryName(nextProps.categoryName).then(res => {
            this.setState({ categories: res.data.payload.cat_name })
        })
    }

    getCategories() {
        ProductsUpload.getCategoryName(this.state.categoryName).then(res => {
            this.setState({ categories: res.data.payload.cat_name })
        })
        ProductsUpload.getCategoryName(this.props.location.state.subCategory).then(res => {
            this.setState({
                subCategory: res.data.payload.cat_name
            })
        })
    }

    getAffiliatorCommissionName() {
        ProductsUpload.getAffiliatorCommissionName(this.props.location.state.affCommission).then(res => {
            this.setState({ affiliatorCommission: res.data.payload.point_value })
        })
    }

    handleCorrect() {
        this.props.history.push({
            pathname: `/product-upload-confirm-edit`,
            state: {
                id: this.props.location.state.id,
                firstTitle: this.props.location.state.firstTitle,
                file: this.props.location.state.file,
                picture: this.props.location.state.picture,
                secondTitle: this.props.location.state.secondTitle,
                seller_id: this.props.location.state.seller_id,
                servicePrice: this.props.location.state.servicePrice,
                expectedDelivary: this.props.location.state.expectedDelivary,
                singleImg: this.props.location.state.singlePicture,
                singleImage: this.props.location.state.singleImage,
                singleImagePicture: this.props.location.state.singleImagePicture,
                delivaryFormat: this.props.location.state.delivaryFormat,
                numberOfOrders: this.props.location.state.numberOfOrders,
                subCategory: this.props.location.state.subCategory,
                Category: this.props.location.state.Category,
                affCommission: this.props.location.state.affCommission,
                includeVat: this.props.location.state.includeVat,
                paidForService: this.props.location.state.paidForService,
                affiliatorPromote: this.props.location.state.affiliatorPromote,
                editor_msg: this.props.location.state.editor_msg,
                IsDraft: this.props.location.state.IsDraft,
                acceptance: this.props.location.state.acceptance,
                selfaff: this.props.location.state.selfaff,
                autoPayment: this.props.location.state.autoPayment,

            }
        })
    }

    handlePublish() {
        this.toggle()
        this.setState({ IsDraft: 1 })
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    getAffiliatorCommission() {
        ProductsUpload.getCategory().then(res => {
            this.setState({ affiliatorCommission: res.data.aff_points })
        })
    }

    acceptance() {
        if (this.props.location.state.acceptance === 'YES') {
            return (
                <div>
                    受け付ける
                </div>
            )
        } else {
            return (
                <div>
                    受け付けしない
                </div>
            )
        }
    }

    delivary() {
        if (this.props.location.state.delivaryFormat === 'video') {
            return (
                <div>
                    動画
                </div>
            )
        } else if (this.props.location.state.delivaryFormat === 'pdf') {
            return (
                <div>
                    PDF
                </div>
            )
        } else if (this.props.location.state.delivaryFormat === 'audio') {
            return (
                <div>
                    音声
                </div>
            )
        } else if (this.props.location.state.delivaryFormat === 'chat') {
            return (
                <div>
                    チャット
                </div>
            )
        }
    }

    selfaffiliate() {
        if (this.props.location.state.selfaff === true) {
            return (
                <span>
                    自己購入可能
                </span>
            )
        } else {
            return (
                <span>
                    
                </span>
            )
        }
    }

    autoPayment() {
        if (this.props.location.state.autoPayment === true) {
            return (
                <span>
                    継続課金
                </span>
            )
        } else {
            return (
                <span>
                    
                </span>
            )
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        document.getElementById("final").disabled = true;
        if (this.props.location.state.picture) {
            if (this.props.location.state.picture === 'undefined' || this.props.location.state.picture === '' || this.props.location.state.picture === null) {
                this.state.picture = '';
            }
            else {
                this.state.picture = this.props.location.state.picture;
            }
        }
        if (this.props.location.state.singleImg || this.props.location.state.singleImage) {
            if (this.props.location.state.singleImg === '' || this.props.location.state.singleImage === '') {
                this.state.singlePictureString = '';
            }
            else {
                this.state.singlePictureString = this.props.location.state.singleImagePicture;
            }
        }

        if (this.props.location.state.id === undefined || this.props.location.state.id === '' || this.props.location.state.id === null) {
            this.state.id = '';
        } else {
            this.state.id = this.props.location.state.id;
        }
       

        const formData = new FormData();
        formData.append('id', this.state.id)
        formData.append('title', this.props.location.state.firstTitle)
        if (this.props.location.state.singleImg != undefined && this.props.location.state.singlePicture == undefined) {
            formData.append('single_picture', this.props.location.state.singleImg);
        } else if (this.props.location.state.singlePicture != undefined && this.props.location.state.singleImg == undefined) {
            formData.append('single_picture', this.props.location.state.singlePicture);
        }
        // formData.append('single_picture', (this.props.location.state.singleImg ? this.props.location.state.singleImg : this.props.location.state.singlePicture))
        formData.append('single_picture_string', this.state.singlePictureString)
        this.props.location.state.picture.map((file) => {
            // console.log('file');
            console.log(file);
            formData.append('file[]', file.file);
            formData.append('file_string[]', file.image);
        });

        // formData.append('file3', this.props.location.state.file[0].file);
        // formData.append('file_string', this.state.picture)
        // formData.append('file', this.state.pictures) //multiple Image
        // formData.append('services', JSON.stringify(this.state.services))
        formData.append('short_desc', this.props.location.state.secondTitle)
        formData.append('seller_id', this.props.location.state.seller_id)
        formData.append('price_int', this.props.location.state.servicePrice)
        formData.append('expected_delivery_days', this.props.location.state.expectedDelivary)
        formData.append('delivery_format', this.props.location.state.delivaryFormat)
        formData.append('no_of_order_at_atime', this.props.location.state.numberOfOrders)
        formData.append('sub_category_id', this.props.location.state.subCategory)
        formData.append('category_id', this.props.location.state.Category)
        formData.append('affiliator_commission', this.props.location.state.affCommission)
        formData.append('commission_in_ex_vat', this.props.location.state.includeVat)
        formData.append('paidForService', this.props.location.state.paidForService)
        formData.append('is_to_be_affiliated', this.props.location.state.affiliatorPromote)
        formData.append('long_desc', this.props.location.state.editor_msg)
        formData.append('is_estimate_or_customizable', this.props.location.state.acceptance)
        formData.append('is_draft', this.props.location.state.IsDraft)
        formData.append('selfaff', this.props.location.state.selfaff)
        formData.append('autoPayment', this.props.location.state.autoPayment)
        console.log(formData)
        // console.log(data)
        axios({
            method: 'post',
            // url: 'http://127.0.0.1/sharework_back_v2/public/backend/upload-product',
            url: 'https://share-work.jp/backend/upload-product',
            data: formData,
            config: {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
        }).then(res => {
            if (res.data.status === 200) {
                alert('正常に公開されました')
                window.location.href = '/service-list';
            }
        }).catch(
            console.log('asd')
        )
    }

    img(image, x) {
        if (image) {
            return (
                < div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                    <img src={image} />
                </div >
            )
        } else {
            return (
                < div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                    <img src={x} />
                </div >
            )
        }
    }

    singleImgshow() {
        let $imagePreview1 = null;
        if (this.props.location.state.singlePicture) {
            let reader = new FileReader();
            let singlePicture = this.props.location.state.singlePicture;
            reader.onloadend = () => {
                this.setState({
                    singlePicture: singlePicture,
                    imagePreviewUrl1: reader.result
                })
            }
            reader.readAsDataURL(singlePicture)
            let { imagePreviewUrl1 } = this.state;
            if (imagePreviewUrl1) {
                $imagePreview1 = (<img src={imagePreviewUrl1} height="100px" width='100px' />)
            }
        }
        if (this.props.location.state.singleImg) {

            let reader = new FileReader();
            let singlePicture = this.props.location.state.singleImg;
            reader.onloadend = () => {
                this.setState({
                    singlePicture: singlePicture,
                    imagePreviewUrl2: reader.result
                })
            }
            reader.readAsDataURL(singlePicture)
            let { imagePreviewUrl2 } = this.state;
            return (
                <div className="">
                    <div className="imgPreview">
                        <img src={imagePreviewUrl2} height='100px' width='100' />
                    </div>
                </div>
            )
        } else if (this.props.location.state.singleImage) {
            return (
                <div className="">
                    <div className="imgPreview">
                        <img src={this.props.location.state.singleImage} height='100px' width='100' />
                    </div>
                </div>

            )
        } else {
            return (
                <div className="">
                    <div className="imgPreview">
                        {$imagePreview1}
                    </div>
                </div>

            )
        }
    }

    imgShow() {
        let $imagePreview = null;
        if (this.props.location.state.picture) {
            return (
                <div className="col-md-12 row">
                    {this.props.location.state.picture.map(p =>
                        this.img(p.img, p.imagePreviewUrl)
                    )}
                </div>
            )
        }
        if (this.props.location.state.img) {
            return (
                <div className="">
                    <div className="">
                        <img src={this.props.location.state.img} height='100px' width='100' />
                    </div>
                </div>
            )
        } else {
            return (
                <div className="imgPreview">
                    {$imagePreview}
                </div>
            )
        }
    }

    uploadConfirmation() {
        // if(this.state.IsDraft){
        return (
            <div>
                <Button style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1" }} className="ml-4"
                    onClick={this.handlePublish.bind(this)} >
                    公開する
                </Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle.bind(this)} >
                    <ModalHeader toggle={this.toggle.bind(this)}></ModalHeader>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    </button>
                    <ModalBody>
                        <div>
                            出品します、よろしいでしょうか？
                        </div>
                    </ModalBody>
                    <ModalFooter style={{ justifyContent: 'center' }}>
                        <Button color="secondary" data-dismiss="modal" onClick={this.toggle.bind(this)}>  いいえ</Button>
                        <div className="ml-2" onClick={this.handleSubmit.bind(this)} >
                            <button id="final" type="submit" className="btn btn-success" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>  はい</button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

    render() {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        let $imagePreview = null;
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="mt-5 mb-3  input_name big_font guide_text" style={{ width: '100%', fontSize: '20px' }}>
                            サービスの出品・編集
                            </div>
                        <form onSubmit={this.handleSubmit.bind(this)}>
                            <div className="row form-group">
                                <div className="col-md-1"></div>
                                <div className="col-md-10" style={{ fontSize: '13px' }}>
                                    <div className="row mt-4" style={{display: "none"}}>
                                        <div className="col-md-3 common_text_bold"> カテゴリー :</div>

                                        <div className="col-md-8" >
                                            {this.state.categories}
                                        </div>
                                    </div>
                                    <div className="row mt-4" style={{display: "none"}}>
                                        <div className="col-md-3 common_text_bold"> 小カテゴリ :</div>

                                        <div className="col-md-8" >
                                            {this.state.subCategory}
                                        </div>
                                    </div>
                                    <div className="row mt-4 ">
                                        <div className="col-md-3 common_text_bold"> サービスタイトル :</div>

                                        <div className="col-md-8">{this.props.location.state.firstTitle}</div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3 common_text_bold"> キャッチコピー :</div>

                                        <div className="col-md-8">{this.props.location.state.secondTitle}</div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3 common_text_bold"> サービス内容 :</div>

                                        <div className="col-md-8">{renderHTML(this.props.location.state.editor_msg)}</div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3 common_text_bold"> トップに表示したい画像 :</div>

                                        <div className="col-md-8">
                                            <div className="" >
                                                {this.singleImgshow()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3 common_text_bold"> 画像 :</div>

                                        <div className="col-md-8">
                                            <div className="" >
                                                {this.imgShow()}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-4">
                                        <div className="col-md-3 common_text_bold"> サービス価格 :</div>

                                        <div className="col-md-8">{this.props.location.state.servicePrice}&nbsp;円&nbsp;&nbsp;&nbsp; <span>{this.autoPayment()}</span></div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3 common_text_bold"> アフィリエイト報酬 :</div>

                                        <div className="col-md-8">{this.state.affiliatorCommission}&nbsp;%  &nbsp;&nbsp;&nbsp; <span>{this.selfaffiliate()}</span></div>
                                    </div>
                                    {/* <div className="row mt-4">
                                        <div className="col-md-3 common_text_bold"> 自己購入 :</div>

                                        <div className="col-md-8">{this.selfaffiliate()}&nbsp;</div>
                                    </div> */}
                                    <div className="row mt-4">
                                        <div className="col-md-3 common_text_bold"> 提供形式 :</div>

                                        <div className="col-md-8">{this.delivary()}</div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3 common_text_bold"> 予想お届け日数 :</div>

                                        <div className="col-md-8">{this.props.location.state.expectedDelivary}  日</div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3 common_text_bold"> 一度に受注可能な件数 :</div>

                                        <div className="col-md-8">{this.props.location.state.numberOfOrders}&nbsp;件</div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3 common_text_bold"> 見積り・カスタマイズの受付 :</div>

                                        <div className="col-md-8">{this.acceptance()}</div>
                                    </div>

                                    <div className="field_width mt-5 " >
                                        <div className="col row">
                                            <div className=" ">
                                                <button type="submit" onClick={this.handleCorrect.bind(this)} className="btn btn-secondary  mr-5" style={{ width: 'auto' }}>修正する</button>
                                            </div>
                                            <div className="">
                                                {this.uploadConfirmation()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-1"></div>
                            </div>
                        </form>
                        {/* </div> */}
                    </div>
                    <Footer />
                </div>
            )
        } else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="mt-5 mb-3  input_name big_font guide_text" style={{ marginLeft: '90px', width: '84%' }}>
                                    サービスの出品・編集
                            </div>
                                <form onSubmit={this.handleSubmit.bind(this)}>
                                    <div className="row form-group">
                                        <div className="col-md-1"></div>
                                        <div className="col-md-10">

                                            {/* <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div> */}
                                            <div className="row mt-4" style={{display: "none"}}>
                                                <div className="col-md-3 common_text_bold"> カテゴリー </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8" >
                                                    {this.state.categories}
                                                </div>
                                            </div>
                                            <div className="row mt-4" style={{display: "none"}}>
                                                <div className="col-md-3 common_text_bold"> 小カテゴリ </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8" >
                                                    {this.state.subCategory}
                                                </div>
                                            </div>
                                            <div className="row mt-4 ">
                                                <div className="col-md-3 common_text_bold"> サービスタイトル </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">{this.props.location.state.firstTitle}</div>
                                            </div>
                                            <div className="row mt-4">
                                                <div className="col-md-3 common_text_bold"> キャッチコピー </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">{this.props.location.state.secondTitle}</div>
                                            </div>
                                            <div className="row mt-4">
                                                <div className="col-md-3 common_text_bold"> サービス内容 </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">{renderHTML(this.props.location.state.editor_msg)}</div>
                                            </div>
                                            <div className="row mt-4">
                                                <div className="col-md-3 common_text_bold"> トップに表示したい画像 </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">
                                                    <div className="" >
                                                        {this.singleImgshow()}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-4">
                                                <div className="col-md-3 common_text_bold"> 画像 </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">
                                                    <div className="" >
                                                        {this.imgShow()}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mt-4">
                                                <div className="col-md-3 common_text_bold"> サービス価格 </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">{this.props.location.state.servicePrice}&nbsp;円&nbsp;&nbsp;&nbsp; <span>{this.autoPayment()}</span></div>
                                            </div>
                                            <div className="row mt-4">
                                                <div className="col-md-3 common_text_bold"> アフィリエイト報酬 </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">{this.state.affiliatorCommission}&nbsp;%&nbsp;&nbsp;&nbsp; <span>{this.selfaffiliate()}</span></div>
                                            </div>
                                            {/* <div className="row mt-4">
                                                <div className="col-md-3 common_text_bold"> 自己購入 </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">{this.selfaffiliate()}&nbsp;</div>
                                            </div> */}
                                            <div className="row mt-4">
                                                <div className="col-md-3 common_text_bold"> 提供形式 </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">{this.delivary()}</div>
                                            </div>
                                            <div className="row mt-4">
                                                <div className="col-md-3 common_text_bold"> 予想お届け日数 </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">{this.props.location.state.expectedDelivary}  日</div>
                                            </div>
                                            <div className="row mt-4">
                                                <div className="col-md-3 common_text_bold"> 一度に受注可能な件数 </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">{this.props.location.state.numberOfOrders}&nbsp;件</div>
                                            </div>
                                            <div className="row mt-4">
                                                <div className="col-md-3 common_text_bold"> 見積り・カスタマイズの受付 </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-8">{this.acceptance()}</div>
                                            </div>

                                            <div className="field_width mt-5 " style={{ marginLeft: '305px' }}>
                                                <div className="row">
                                                    <div className=" mr-5">
                                                        <button type="submit" onClick={this.handleCorrect.bind(this)} className="btn btn-secondary  mr-4" style={{ width: 'auto' }}>修正する</button>
                                                    </div>
                                                    <div className="ml-5">
                                                        {this.uploadConfirmation()}
                                                        {/* <button type="submit" onClick={this.handlePublish.bind(this)} className="btn btn-success ">公開する</button> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-1"></div>
                                    </div>
                                </form>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
const mapStateToProps = (state) => ({
    productUpload: state.productUpload,
    errors: state.errors,
    categories: state.categories,
});

ProductUploadConfirmation = connect(mapStateToProps, { productUpload })(withRouter(ProductUploadConfirmation));

export { ProductUploadConfirmation }